import validate from '../../../services/reduxValidate.js';

export default function(data) {
  const validators = {
    'offer.tjm': {
      numericality: {
        greaterThan: 0,
        onlyInteger: true,
        notGreaterThan: 'Le TJM indicatif doit être supérieur a 0€'
      }
    },
    'offer.start_date': { isoDate: true, presence: { allowEmpty: false } },
    'offer.city': {
      presence: {
        allowEmpty: true,
        message: 'La ville est invalide'
      }
    },
    'offer.title': {
      presence: {allowEmpty: false}
    },
    'offer.logo': {
      presence: {allowEmpty: false}
    },
    'offer.manager': {
      presence: {allowEmpty: false}
    },
    'offer.sub_universes': {
      presence: {allowEmpty: false}
    },
    'offer.duration': {
      presence: {allowEmpty: false}
    },
    'offer.secteurs': {
      length: {
        maximum: 1,
        minimum: 1,
        tooLong: 'Vous ne pouvez saisir qu\'un seul secteur d\'activités',
        tooShort: 'Vous devez saisir au minimum 1 élément'
      },
    },
    'offer.keywords': {
      presence: true,
      length: {
        maximum: 10,
        minimum: 1,
        tooLong: 'Vous devez saisir au maximum 10 éléments',
        tooShort: 'Vous devez saisir au minimum 1 élément'
      },
    },
  };

  return validate(data, validators);
}